import type { TodoItem } from "@acto/ambient-context-schema";
import type Todo from "@acto/taskpane/core/domain/Todo";
import { capList, toIsoDate } from "./helpers";

const toTodoItem = (t: Todo): TodoItem => ({
  title: t.title,
  description: t.description || undefined,
  kind: t.isWorkflow ? "workflow" : t.isNoteBased ? "recap" : "todo",
  due_date: toIsoDate(t.dueDate),
  client_external_reference: t.client?.externalReference,
  client_name: t.client?.name,
});

export interface TodoBucketsInput {
  overdue?: Todo[];
  open?: Todo[];
  completed?: Todo[];
}

/**
 * Rendered todo buckets → schema bucket fields. A bucket absent from the input
 * (hidden by the active filter) stays unset, so the envelope mirrors what is
 * actually on screen.
 */
export function todosToBuckets(
  { overdue, open, completed }: TodoBucketsInput,
  { limit }: { limit?: number } = {},
): { overdue_todos?: TodoItem[]; open_todos?: TodoItem[]; completed_todos?: TodoItem[] } {
  return {
    overdue_todos: overdue ? capList(overdue, limit).map(toTodoItem) : undefined,
    open_todos: open ? capList(open, limit).map(toTodoItem) : undefined,
    completed_todos: completed ? capList(completed, limit).map(toTodoItem) : undefined,
  };
}
